import { Language } from '../ts/customTypes';
import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { it } from './it';
import { nl } from './nl';

export const languages: Language[] = [
    de, en, es, fr, it, nl
];